import React, { useState, useEffect } from 'react';
import CSTop from '../CS/CSTop';
import InputSearch from '../common/InputSearch';
import HButton from '../common/HButton';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { listLicenceKeys } from '../../modules/cs';
import DevicePagination from './DevicePagination';
import { fetchAllLicenceKeys } from '../../lib/api/cs';
import DropdownList from '../auth/styled/DropdownList';

const Content = styled.div`
  margin: 0 auto;
  width: 1250px;
  min-width: 1250px;
  padding: 64px 40px 40px 40px;

  table.device {
    border-collapse: collapse;
    text-align: center;
    line-height: 1.5;
    width: 100%;
    margin-bottom: 32px;
    color: #212529;
  }

  table.device thead {
    background-color: white;
  }
  table.device thead th {
    min-width: 50px;
  }
  table.device th {
    font-family: 'Source Sans Pro';
    font-weight: 600;
    font-size: 15px;
    color: #59616a;
    vertical-align: middle !important;
  }

  table.device td,
  table.device th {
    padding: 0.75rem;
    border: 1px solid #e7e9ea;
  }

  table.device tbody {
    vertical-align: middle;
  }
  table.device td {
    font-family: 'Source Sans Pro';
    font-size: 15px;
    color: rgba(48, 57, 69, 0.8);
  }
`;

const TableTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  font-size: 25px;
  color: #59616a;
  margin-bottom: 24px;
`;

const C4WLicense = () => {
  const dispatch = useDispatch();
  const { licenceKeys, loading } = useSelector(({ cs, loading }) => ({
    licenceKeys: cs.licenceKeys,
    loading: loading['cs/LIST_LICENCE_KEYS'],
  }));
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [orderBy, setOrderBy] = useState('activated_at asc');
  const [statusFilter, setStatusFilter] = useState('All');

  useEffect(() => {
    dispatch(listLicenceKeys({ filters: { orderBy }, page }));
  }, [dispatch, orderBy, page]);

  const onSetPage = (newPage) => setPage(newPage);

  const onOrderByActivationDate = () => {
    setOrderBy(
      orderBy === 'activated_at desc' ? 'activated_at asc' : 'activated_at desc',
    );
  };

  const filteredLicences = licenceKeys && Array.isArray(licenceKeys.results)
  ? licenceKeys.results.filter(
      (lic) =>
        (lic.licencekey?.toLowerCase().includes(search.toLowerCase()) ||
         lic.udi?.toLowerCase().includes(search.toLowerCase())) &&
        (statusFilter === 'All' || lic.licence_status === statusFilter)
    )
  : [];

  const onSearchEnter = (value) => {
    setSearch(value);
  };

  const onClickDownloadExcel = async () => {
    const xlsx = await import('xlsx');
    const FileSaver = await import('file-saver');
  
    const allLicences = await fetchAllLicenceKeys();
  
    const ws = xlsx.utils.aoa_to_sheet([
      ['Licence Key', 'Activated At', 'UDI', 'Licence Status'],
      ...allLicences.map((license) => [
        license.licencekey,
        license.activated_at ? license.activated_at.split('T')[0] : '',
        license.udi,
        license.licence_status,
      ]),
    ]);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
    const fileData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    FileSaver.saveAs(fileData, 'C4W_Licenses.xlsx');
  };

  return (
    <>
      <CSTop />
      <Content>
        <TableTop>
          <div>C4W Licence</div>
          <div>
            <HButton
              category="Tertiary"
              size="Medium"
              text={'Download Excel File'.toUpperCase()}
              onClick={onClickDownloadExcel}
            />
          </div>
        </TableTop>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '24px', width: '100%', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', gap: '16px' }}>
          <InputSearch
            size="Medium"
            placeholder={'Search'}
            width="355px"
            value={search}
            onSearchEnterPress={setSearch}
            onChange={(e) => setSearch(e.target.value)}
          />
          <DropdownList
            width="180px"
            height="40px"
            defaultValue="All"
            items={['All', 'used', 'notused', 'rejected']}
            onSelect={setStatusFilter}
            zIndex={1}
          />
        </div>
          <HButton
            category="Primary"
            size="Medium"
            text={'C4W Licence Registration'.toUpperCase()}
            onClick={() => {
              window.location.href = '/adm/c4wLicence';
            }}
          />
        </div>
        {licenceKeys && licenceKeys.pageInfo && (
          <div
            style={{
              float: 'right',
              height: '20px',
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Source Sans Pro',
              fontSize: '15px',
              color: '#303945cc',
              marginBottom: '15px',
            }}
          >
            Total Licences: {licenceKeys.pageInfo.total}
          </div>
        )}
        <table className="device" style={{ marginTop: '24px', width: '100%' }}>
          <thead>
            <tr>
              <th>Licence Key</th>
              <th onClick={onOrderByActivationDate} style={{ cursor: 'pointer' }}>
                Activated At {orderBy.includes('desc') ? '▼' : '▲'}
              </th>
              <th>UDI</th>
              <th>Licence Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center' }}>
                  Loading...
                </td>
              </tr>
            ) : filteredLicences.length > 0 ? (
              filteredLicences.map((license) => (
                <tr key={license.id}>
                  <td>{license.licencekey}</td>
                  <td>
                    {license.activated_at ? license.activated_at.split('T')[0] : ''}
                  </td>
                  <td>{license.udi}</td>
                  <td>{license.licence_status}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center' }}>
                  No licenses found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {licenceKeys && licenceKeys.pageInfo && (
          <DevicePagination pageInfo={licenceKeys.pageInfo} paginate={onSetPage} />
        )}
      </Content>
    </>
  );
};

export default C4WLicense;